module.exports = __webpack_public_path__ + "img/rp-flow-path.25089ec2.png";